import { UserRole } from "./User";

export type RolePermissionMatrix = Record<UserRole, SprintAccessRight[]>;

export enum SprintAccessRight {
    AssetsReadWrite = "assets.readwrite",
    AssetsRead = "assets.read",
    CiRead = "ci.read",
    CiReadWrite = "ci.readwrite",
    CiAdmin = "ci.admin",
    AdminReadWrite = "admin.readwrite",
    AdminRead = "admin.read",
    AdminAdmin = "admin.admin",
    CatReadWrite = "cat.readwrite",
    OrdReadWrite = "ord.readwrite",
    OrdRead = "ord.read",
    OrdAdmin = "ord.admin",
    QcAdmin = "qc.admin",
    MonitRead = "monit.read"
}
export const assetsAccessRightsMatrix: RolePermissionMatrix = {
    Admin: [
        SprintAccessRight.CiReadWrite,
        SprintAccessRight.CiAdmin,
        SprintAccessRight.CiRead,
        SprintAccessRight.AssetsRead,
        SprintAccessRight.AssetsReadWrite,
        SprintAccessRight.AdminReadWrite,
        SprintAccessRight.AdminRead,
        SprintAccessRight.CatReadWrite,
        SprintAccessRight.OrdReadWrite,
        SprintAccessRight.OrdRead,
        SprintAccessRight.OrdAdmin,
        SprintAccessRight.QcAdmin,
        SprintAccessRight.MonitRead
    ],
    Hub: [
        SprintAccessRight.CiReadWrite,
        SprintAccessRight.CiRead,
        SprintAccessRight.AssetsRead,
        SprintAccessRight.AssetsReadWrite,
        SprintAccessRight.AdminRead,
        SprintAccessRight.OrdReadWrite,
        SprintAccessRight.OrdRead,
        SprintAccessRight.MonitRead
    ],
    User: [
        SprintAccessRight.CiRead,
        SprintAccessRight.AssetsRead,
        SprintAccessRight.AdminRead,
        SprintAccessRight.OrdRead,
        SprintAccessRight.MonitRead
    ]
};
